// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-3r749an5dnsjvth4rf4ahq3ugm82fkdue5hhvrugch74np4c3wctjaqn13r9djva7342czw628n9eb1jk1c4e6bfmt7bep4eb45fvcz","loading":"loading-29ghtgcd4jg8f4xk7nyr84n9xjmaptbgbsm2p1fpdfbsv9jkykazc6egsgje86qdnzkrr9514651mznd1hv8haqhwg3d87nsq5t1pzh","pulse":"pulse-2bkqs368nbbddjjupfr5sbvy9vqq3qmeuphvd7mug5jsdgaanzkxh61bdd7y49hsvkyhka36suur848zh3m13ytpc2v2pp61ed3awd8"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Whistleblowing/Whistleblowing.module.scss
// module id = 1792
// module chunks = 0